<template>
  <div>
    <div class="h-dialogContainer">
      <template>
        <ParseForm
          ref="basic"
          :formId="formItems.basic.formId"
          :formParams="formItems.basic.formObj"
          :opCode="opCode"
          :funcClick="bindClickInterface"
        ></ParseForm>
      </template>
      <UsersubProfileList ref="profileList" :getCheckedDatas="getCheckedList" :ne="ne"></UsersubProfileList>
    </div>
  </div>
</template>

<script>
import ParseForm from "../../../util/parseFormNew/ParseForm";
import UsersubProfileList from "./UsersubProfileList";
import SubscriberTool from "../../../util/parseFormNew/tools/subscriberTool";
import ajaxUrl from "../../../data/ajaxUrl";
import { EventBus } from "../../../../../plugins/eventBus";

export default {
  name: "AddBatchUserForm",
  components: {
    ParseForm,
    UsersubProfileList
  },
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.basic) {
        if (!this.$refs.basic.validateResult()) {
          console.log("表单验证不通过");
          return false;
        }
        const maps = this.$refs.basic.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      return map;
    },
    getJson(ne, callback) {
      this.ne = ne;
      const params = {
        msgid: this.msgId,
        neid: ne.neid
      };
      this.$axios.post(ajaxUrl.udmJsonReq, params).then(response => {
        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("getJson response.data.errorCode error");
          callback(response);
          return;
        }
        let checkedDatas={coreNetworkType:"3"};//excel默认值目前暂时这样写
        const res = response.data.resultVal;
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(res, checkedDatas);
        this.formItems.basic.formObj = resultMap.get(
          this.formItems.basic.modelName
        );
        callback(response);
      });
    },
    async saveBatchUser(ne, callback) {
      this.neId = ne;
      const formData = this.getDatas();
      if (formData) {
        const startSupi = formData.get("supi");
        const opCount = formData.get("count");
        const addUserList = [];
        if (
          parseInt(formData.get("supi")) + parseInt(opCount) - 1 >
          999999999999999
        ) {
          this.$loading.hideLoadding();
          EventBus.$emit("toast", {
            type: "warning",
            content: this.$t("Supi.exceedSupi")
          });
          return;
        }
        if (
          parseInt(formData.get("gpsi")) + parseInt(opCount) - 1 >
          999999999999999
        ) {
          this.$loading.hideLoadding();
          EventBus.$emit("toast", {
            type: "warning",
            content: this.$t("Supi.exceedGpsi")
          });
          return;
        }
        let startSupiSize = startSupi.length; //加的数若位数小于起始数则补齐0
        for (let i = 0; i < opCount; i++) {
          let datai = (Number(startSupi) + i).toString();
          let dataiSize = datai.length;
          if (dataiSize < startSupiSize) {
            for (let z = 0; z < startSupiSize - dataiSize; z++) {
              datai = "0" + datai; //不够的就在前面补0
            }
          }
          addUserList.push({
            supi: datai
          });
        }
        this.sendAddUserList = addUserList;
        let supiEvery100 = formData.get("supi");
        let gpsiEvery100 = formData.get("gpsi");
        let countAll = parseInt(formData.get("count"));
        let numAxios = parseInt(countAll / 100); //取整
        let numAxiosLast = countAll % 100; //取余数
        let countEach = 100;

        if (numAxios > 0) {
          if (numAxiosLast == 0) {
            //整数
            for (let i = 0; i < numAxios; i++) {
              let paramsEach = {
                vo: {
                  neid: this.neId.neid,
                  supi: parseInt(supiEvery100) + i * 100 + "",
                  gpsi: parseInt(gpsiEvery100) + i * 100 + "",
                  count: 100,
                  randomKeyFlg: formData.get("randomKeyFlg"),
                  k: formData.get("k"),
                  amf: formData.get("amf"),
                  op: formData.get("op"),
                  userProfileId: formData.get("userProfileId"),
                  coreNetworkType: (formData.get("coreNetworkType")==3)?1:0,
                },
                info: {
                  msgid: this.msgId,
                  neid: this.neId.neid
                }
              };

              await this.$axios
                .post(ajaxUrl.requestCommonD, paramsEach)
                .then(response => {
                  if (this.responseIsFailed(response)) {
                    this.$loading.hideLoadding();
                    return;
                  }

                  this.resultValAll = this.resultValAll.concat(
                    response.data.resultVal.resultCode
                  );
                  this.resultCodeStr = this.resultCodeStr.concat(
                    response.data.resultVal.resultCodeStr
                  );
                  if (i == numAxios - 1) {
                    response.data.resultVal.resultCode = this.resultValAll;
                    response.data.resultVal.resultCodeStr = this.resultCodeStr;

                    callback(response, this.sendAddUserList);
                  }
                });
            }
          } else {
            for (let i = 0; i <= numAxios; i++) {
              if (i == numAxios && numAxios > 0 && numAxiosLast != 0) {
                countEach = countAll - numAxios * 100; //整数部分下发后剩余部分下发
              }
              let paramsEach = {
                vo: {
                  neid: this.neId.neid,
                  supi: parseInt(supiEvery100) + i * 100 + "",
                  gpsi: parseInt(gpsiEvery100) + i * 100 + "",
                  count: countEach,
                  randomKeyFlg: formData.get("randomKeyFlg"),
                  k: formData.get("k"),
                  amf: formData.get("amf"),
                  op: formData.get("op"),
                  userProfileId: formData.get("userProfileId"),
                  coreNetworkType: (formData.get("coreNetworkType")==3)?1:0,
                },
                info: {
                  msgid: this.msgId,
                  neid: this.neId.neid
                }
              };
              await this.$axios
                .post(ajaxUrl.requestCommonD, paramsEach)
                .then(response => {
                  if (this.responseIsFailed(response)) {
                    this.$loading.hideLoadding();
                    return;
                  }
                  this.resultValAll = this.resultValAll.concat(
                    response.data.resultVal.resultCode
                  );
                  this.resultCodeStr = this.resultCodeStr.concat(
                    response.data.resultVal.resultCodeStr
                  );

                  if (i == numAxios) {
                    response.data.resultVal.resultCode = this.resultValAll;
                    response.data.resultVal.resultCodeStr = this.resultCodeStr;

                    callback(response, this.sendAddUserList);
                  }
                });
            }
          }
        } else if (numAxios == 0 && numAxiosLast != 0) {
          //没有整数部分即不到100，全下发
          const paramsLast = {
            vo: {
              neid: ne.neid,
              supi: formData.get("supi"),
              gpsi: formData.get("gpsi"),
              count: parseInt(formData.get("count")),
              randomKeyFlg: formData.get("randomKeyFlg"),
              k: formData.get("k"),
              amf: formData.get("amf"),
              op: formData.get("op"),
              userProfileId: formData.get("userProfileId"),
              coreNetworkType: (formData.get("coreNetworkType")==3)?1:0,
            },
            info: {
              msgid: this.msgId,
              neid: ne.neid
            }
          };
          this.$axios
            .post(ajaxUrl.requestCommonD, paramsLast)
            .then(response => {
              if (callback) {
                callback(response, addUserList);
              }
            });
        }
      } else {
        this.$loading.hideLoadding();
      }
    },
    responseIsFailed(response) {
      if (!response) {
        console.log("response error");
        return true;
      }
      if (!response.data) {
        console.log("response.data error");
        return true;
      }
      if (!response.data.resultVal) {
        console.log("response.data.resultVal error");
        return true;
      }
      if (0 !== response.data.resultVal.result) {
        EventBus.$emit("toast", {
          type: "warning",
          content: response.data.errorString
        });
        return true;
      }
      return false;
    },

    getCheckedList(list) {
      if (this.$refs.basic) {
        this.$refs.basic.setData("userProfileId", list[0] || "");
      }
    },
    onclickProfileId() {
      this.$refs.profileList.qryList(this.ne);
      this.$refs.profileList.show();
    }
  },
  computed: {
    bindClickInterface() {
      this.funcMap = new Map();
      this.funcMap.set("userProfileId", () => {
        this.onclickProfileId();
      });
      return this.funcMap;
    }
  },
  data() {
    return {
      ne: null,
      id: 0,
      funcMap: null,
      list: [],
      formItems: {
        basic: {
          formId: "SupiAddBatchBasicInfo",
          modelName: "basic",
          formObj: null
        }
      },
      opCode: "add",
      msgId: "28696",
      timer1: null,
      neId: {},
      resultValAll: [],
      resultCodeStr: [],
      sendAddUserList: []
    };
  },
  beforeDestroy() {}
};
</script>
